import { FC, memo, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'app/hooks';
import { setMobileAppModalOpen } from '../../request-single-page-slice';
import { selectMobileAppModalOpen } from '../../selectors';
import { MobileStore } from '../../types';
import { Tabs, QrStore, Description } from './components';
import { Container, QrWrapper } from './mobile-app-modal.styled';

export const MobileAppModal: FC = memo(() => {
  const dispatch = useAppDispatch();
  const modalRef = useRef<HTMLDivElement>(null);
  const show = useSelector(selectMobileAppModalOpen);
  const [tab, setTab] = useState<MobileStore>('ru');

  const closeModal = () => {
    dispatch(setMobileAppModalOpen(false));
    setTab('ru');
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      dispatch(setMobileAppModalOpen(false));
      setTab('ru');
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);

  if (!show) return null;

  return (
    <Container ref={modalRef}>
      <QrWrapper>
        <Tabs activeTab={tab} setTab={setTab} />
        <QrStore store={tab} />
      </QrWrapper>
      <Description closeModal={closeModal} />
    </Container>
  );
});
